import { Component } from '@angular/core';

@Component({
  selector: 'app-mad-buttons-demo-api-spec',
  imports: [],
  templateUrl: './mad-buttons-demo-api-spec.component.html',
  styleUrl: './mad-buttons-demo-api-spec.component.scss',
})
export class MadButtonsDemoApiSpecComponent {}
